import React, { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';

import { SearchOutlined } from '@ant-design/icons';
import {
  Input,
  Button,
  Space,
} from 'antd';

import { Container } from './styles';

const Filter = (columnName, dataIndex, propIndex) => {
  const ref = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  const handleSearch = (selectedKeys, confirm, index) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(index);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  return ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <Container>
        <Input
          ref={ref}
          placeholder={`Buscar ${columnName}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Burcar
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Limpar
          </Button>
        </Space>
      </Container>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const valueData = record[dataIndex];
      if (propIndex) {
        return valueData[propIndex].toString().toLowerCase().includes(value.toLowerCase());
      }

      return valueData.toString().toLowerCase().includes(value.toLowerCase());
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => ref.current.select());
      }
    },
    render: (text, record) => {
      const dataText = propIndex
        ? record[dataIndex]
          ? record[dataIndex][propIndex]
          : record[dataIndex]
        : text;
      if (searchedColumn === dataIndex) {
        return (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={dataText.toString()}
          />
        );
      }

      return dataText;
    },
  });
};

export default Filter;
export { default as ColumnSelect } from './Select';
